import { useEffect, useState } from "react";
import axios from "../api/axios";

export default function TaskManager() {
  const [bloques, setBloques] = useState([]);

  useEffect(() => {
    cargar();
  }, []);

  const cargar = async () => {
    const r = await axios.get("/agenda");
    const normalizados = (r.data || []).map((b) => ({
      ...b,
      tareas: b.TareaItem || b.tareas || [],
    }));
    setBloques(normalizados);
  };

  // ===========================
  // NUEVO BLOQUE
  // ===========================
  const crearBloque = async () => {
    const nombre = window.prompt("Nombre del bloque:");
    if (!nombre || !nombre.trim()) return;

    const r = await axios.post("/agenda/bloque", { nombre: nombre.trim() });
    setBloques([{ ...r.data, tareas: [] }, ...bloques]);
  };

  const borrarBloque = async (id) => {
    await axios.delete(`/agenda/bloque/${id}`);
    setBloques(bloques.filter((b) => b.id !== id));
  };

  // ===========================
  // TAREAS
  // ===========================
  const crearTarea = async (bloqueId) => {
    const texto = window.prompt("Nueva tarea:");
    if (!texto || !texto.trim()) return;

    const hoy = new Date().toISOString();

    const r = await axios.post("/agenda/tarea", {
      bloqueId,
      texto: texto.trim(),
      creadoEn: hoy,
    });

    setBloques(
      bloques.map((b) =>
        b.id === bloqueId ? { ...b, tareas: [...b.tareas, r.data] } : b
      )
    );
  };

  const borrarTarea = async (tareaId) => {
    await axios.delete(`/agenda/tarea/${tareaId}`);

    setBloques(
      bloques.map((b) => ({
        ...b,
        tareas: b.tareas.filter((t) => t.id !== tareaId),
      }))
    );
  };

  const toggleCompletada = async (bloqueId, tarea) => {
    const nuevo = !tarea.completada;

    setBloques(
      bloques.map((b) =>
        b.id === bloqueId
          ? {
              ...b,
              tareas: b.tareas.map((t) =>
                t.id === tarea.id ? { ...t, completada: nuevo } : t
              ),
            }
          : b
      )
    );

    await axios.put(`/agenda/tarea/${tarea.id}`, { completada: nuevo });
  };

  const actualizarTextoLocal = (bloqueId, tareaId, value) => {
    setBloques((prev) =>
      prev.map((b) =>
        b.id === bloqueId
          ? {
              ...b,
              tareas: b.tareas.map((t) =>
                t.id === tareaId ? { ...t, texto: value } : t
              ),
            }
          : b
      )
    );
  };

  const actualizarObsLocal = (bloqueId, tareaId, value) => {
    setBloques((prev) =>
      prev.map((b) =>
        b.id === bloqueId
          ? {
              ...b,
              tareas: b.tareas.map((t) =>
                t.id === tareaId ? { ...t, observaciones: value } : t
              ),
            }
          : b
      )
    );
  };

  const actualizarFechaLocal = (bloqueId, tareaId, value) => {
    setBloques((prev) =>
      prev.map((b) =>
        b.id === bloqueId
          ? {
              ...b,
              tareas: b.tareas.map((t) =>
                t.id === tareaId ? { ...t, creadoEn: value } : t
              ),
            }
          : b
      )
    );
  };

  const fmtInput = (f) => {
    if (!f) return "";
    return new Date(f).toISOString().slice(0, 10);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {/* CABECERA: AGENDA */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span style={{ fontWeight: 700, fontSize: 13 }}>AGENDA</span>

        <button
          onClick={crearBloque}
          style={{
            fontSize: 12,
            padding: "4px 8px",
            borderRadius: 6,
            border: "1px solid #3b82f6",
            background: "transparent",
            color: "#bfdbfe",
            cursor: "pointer",
          }}
        >
          Nuevo bloque
        </button>
      </div>

      {/* BLOQUES */}
      {bloques.map((b) => (
        <div key={b.id} style={{ marginTop: 6 }}>
          {/* CABECERA BLOQUE */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: 10,
            }}
          >
            <span style={{ fontWeight: 600, fontSize: 13 }}>{b.nombre}</span>

            <div style={{ display: "flex", gap: 10 }}>
              <span
                onClick={() => crearTarea(b.id)}
                style={{
                  fontSize: 12,
                  cursor: "pointer",
                  color: "#93c5fd",
                  textDecoration: "underline",
                }}
              >
                Añadir tarea
              </span>

              <span
                onClick={() => borrarBloque(b.id)}
                style={{ fontSize: 12, cursor: "pointer", color: "#ef4444" }}
              >
                X
              </span>
            </div>
          </div>

          {/* TAREAS */}
          <div
            style={{
              marginLeft: 26,
              marginTop: 4,
              display: "flex",
              flexDirection: "column",
              gap: 4,
            }}
          >
            {b.tareas.map((t) => (
              <div
                key={t.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  opacity: t.completada ? 0.45 : 1,
                }}
              >
                {/* TEXTO */}
                <input
                  value={t.texto}
                  onChange={(e) =>
                    actualizarTextoLocal(b.id, t.id, e.target.value)
                  }
                  onBlur={(e) =>
                    axios.put(`/agenda/tarea/${t.id}`, {
                      texto: e.target.value,
                    })
                  }
                  style={{
                    flex: 2,
                    border: "none",
                    borderBottom: "1px dotted #555",
                    background: "transparent",
                    color: "white",
                    outline: "none",
                  }}
                />

                {/* FECHA editable */}
                <input
                  type="date"
                  value={fmtInput(t.creadoEn)}
                  onChange={(e) =>
                    actualizarFechaLocal(b.id, t.id, e.target.value)
                  }
                  onBlur={(e) =>
                    axios.put(`/agenda/tarea/${t.id}`, {
                      creadoEn: e.target.value,
                    })
                  }
                  style={{
                    flex: 1,
                    border: "none",
                    borderBottom: "1px dotted #555",
                    background: "transparent",
                    color: "white",
                    outline: "none",
                    fontSize: 12,
                  }}
                />

                {/* OBSERVACIONES */}
                <input
                  value={t.observaciones || ""}
                  onChange={(e) =>
                    actualizarObsLocal(b.id, t.id, e.target.value)
                  }
                  onBlur={(e) =>
                    axios.put(`/agenda/tarea/${t.id}`, {
                      observaciones: e.target.value,
                    })
                  }
                  style={{
                    flex: 3,
                    border: "none",
                    borderBottom: "1px dotted #555",
                    background: "transparent",
                    color: "white",
                    outline: "none",
                  }}
                  placeholder="..."
                />

                {/* ✓ */}
                <span
                  onClick={() => toggleCompletada(b.id, t)}
                  style={{
                    cursor: "pointer",
                    color: "#22c55e",
                    fontWeight: 700,
                    fontSize: 16,
                  }}
                >
                  ✓
                </span>

                {/* X */}
                <span
                  onClick={() => borrarTarea(t.id)}
                  style={{
                    cursor: "pointer",
                    color: "#ef4444",
                    fontWeight: 700,
                    fontSize: 16,
                  }}
                >
                  X
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
